export const LOADING_TYPES = {
  RESET_PASSWORD_VALIDATE_CODE: 'validate_code',
  EMAIL: 'email',
  // show loader on full page
  FULL_PAGE: 'full_page',
};

export const FORCE_REDIRECT_TO_TARGET = 'force-redirect-to-target';
